import { ReactNode } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Heading, Variant, Style } from './Heading'

export interface CardProps {
  imgSrc: StaticImageData | string
  imgAlt: string
  title: string
  content: string | ReactNode
  children: ReactNode
  cardHref?: string
}

export function ContentCardImageOnTop({
  imgSrc,
  imgAlt,
  title,
  content,
  children,
  cardHref,
}: CardProps) {
  return (
    <div className="flex flex-col max-w-352px mb-12 mx-auto md:max-w-auto md:mb-0 lg:mx-0">
      <div className="relative">
        {cardHref ? (
          <Link href={cardHref}>
            <a>
              <Image
                src={imgSrc}
                {...(typeof imgSrc === 'string'
                  ? { objectFit: 'cover', width: 700, height: 500 }
                  : { placeholder: 'blur' })}
                alt={imgAlt}
                loader={({ src }) => {
                  return src;
                }}
              />
            </a>
          </Link>
        ) : (
          <Image
            src={imgSrc}
            {...(typeof imgSrc === 'string'
              ? { objectFit: 'cover', width: 700, height: 500 }
              : { placeholder: 'blur' })}
            alt={imgAlt}
            loader={({ src }) => {
              return src;
            }}
          />
        )}
      </div>
      <div className="-mt-6 bg-white flex-auto px-4 py-8 relative shadow-contentCardShadow z-10">
        {cardHref ? (
          <Link href={cardHref}>
            <a>
              <Heading
                className="mb-6"
                variant={Variant.h3}
                cssStyle={Style.h3}
                headingText={title}
              />
            </a>
          </Link>
        ) : (
          <Heading
            className="mb-6"
            variant={Variant.h3}
            cssStyle={Style.h3}
            headingText={title}
          />
        )}
        <p className="mb-10">{content}</p>
        {children && (
          <div className="absolute bottom-8">
            <div className="flex flex-col flex-wrap gap-y-6 pt-4">
              {children}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
